export default __webpack_public_path__ + "static/media/poi-tile-arrow.def70521.svg";